module.exports = __webpack_public_path__ + "img/Site_elin_gif.82706c17.gif";